<template>
  <div v-if="(slotIcon && !value) || value.indexOf('base64') > 0" class="linear-gradient"></div>
  <!-- <video v-else-if="isVideo"
         :height="waterFull?'':'100%'"
         style="max-width:100%;"
         :controls="controls"
         webkit-playsinline="true"
         playsinline="true"
         :src="changeUrl(value)"></video> -->
  <Video v-else-if="isVideo" :src="changeUrl(value)" width="100%" height="100%"></Video>
  <img v-else :style="{ 'object-fit': isFullHeight ? 'contain' : '' }" class="z-image" :src="reailVal" />
</template>
<script>
import Video from './videos.vue'
export default {
  name: 'ZImage',
  components: {
    Video
  },
  props: {
    value: {
      type: String,
      required: true
    },
    errorSrc: {
      type: String
    },
    slotIcon: {
      type: Boolean,
      default: true
    },
    waterFull: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isVideo() {
      var ty = false
      if (this.value && this.value.indexOf('.avif') > 0) {
        return
      }
      if (this.value && this.value.indexOf('.mp4') > 0) {
        ty = true
      }
      if (this.value && this.value.indexOf('.flv') > 0) {
        ty = true
      }
      if (this.value && this.value.indexOf('.rmvb') > 0) {
        ty = true
      }
      if (this.value && this.value.indexOf('.wmv') > 0) {
        ty = true
      }
      if (this.value && this.value.indexOf('.avi') > 0) {
        ty = true
      }
      if (this.value && this.value.indexOf('.mov') > 0) {
        ty = true
      }
      if (this.value && this.value.indexOf('.rm') > 0) {
        ty = true
      }
      return ty
    },
    reailVal() {
      var val = this.changeUrl(this.value)
      if (!val) {
        val = this.errorSrc
      }
      return val
    },
    isFullHeight() {
      return this.getQuery('appIdStr') == 'orgic' || this.getQuery('appIdStr') == 'sqsjyxglzpt'
    }
    // isHome(){
    //   return this.$route.name == 'Next'
    // }
  }
  // mounted(){
  // if (this.$flvjs.isSupported()&&this.isFlv) {
  //     var flvUrl = this.value;
  //     var videoElement = document.getElementById('vElement');
  //     var flvPlayer = this.$flvjs.createPlayer({
  //         type: 'flv',
  //         url: flvUrl
  //     });
  //     flvPlayer.attachMediaElement(videoElement);
  //     flvPlayer.load();
  // }
  // },
}
</script>
<style scoped>
.linear-gradient {
  position: relative;
  width: 100%;
  height: 100%;
  /* background-image: linear-gradient(30deg, #e1d5eb, #44b5ef); */
  background-color: #ededed;
}
.linear-gradient .logo-icon-imtex {
  width: initial;
  height: initial;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -35px 0 0 -35px;
}
.z-image {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
  object-fit: scale-down;
}
</style>



// WEBPACK FOOTER //
// src/components/ZImage.vue